class ConnectionError extends Error {
  constructor (error, message = error.message) {
    super(`ConnectionError: ${message}`)
    this.original = error

    this.stack = this.stack.split('\n').slice(0, 2).join('\n') + '\n' + error.stack
  }
}

export default ConnectionError
